export const isEmpty = (
  string,
  shouldTrim = false,
) => !string || (shouldTrim ? string.trim() : string).length === 0

export const isInvalidValue = (string) => string === 'null' || string === 'undefined'
